import { components } from 'react-select';

const DropdownIndicator = (props: any) => {
	return (
		<components.DropdownIndicator {...props}>
			<em aria-hidden="true" className="icon-arrow-right"></em>
		</components.DropdownIndicator>
	);
};

export default DropdownIndicator;
